/* eslint-disable */
<template>
  <div class="login-wrapper border-light">
    <form class="form-signin" @submit.prevent="login">
      <img class="login-logo" src="@/assets/jom-simple-logo-ios-splash-transparent.png">
      <label for="inputEmail" class="sr-only">Email address</label>
      <input v-model="loginForm.email" type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus>
      <label for="inputPassword" class="sr-only">Password</label>
      <input v-model="loginForm.password" type="password" id="inputPassword" class="form-control" placeholder="Password" required>
      <button class="btn btn-lg btn-primary btn-block" type="submit"><span>LOGIN</span></button>
    </form>
    <div id="divMessage">{{ errorMsg }} </div>
  </div>
</template>

<script>
import ApiService from '@/services/api/Mainapi'
export default {
/* eslint-disable */
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      rules: {
        required: value => !!value || '<text style="color:red">Required</text>',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      errorMsg: ''
    }
  },
  props: [
    'state',
    'client_id',
    'response_type',
    'scope',
    'redirect_uri'
  ],
  methods: {
    login () {
      this.performingRequest = true
      // alert(this.loginForm.email + "   " + this.loginForm.password)
      let self = this
      ApiService.signIn(this.loginForm.email, this.loginForm.password).then(response => {
        // alert(JSON.stringify(user))

        let user = response.data;
        let headers = response.headers;

        let access_token = headers['access-token'];
        let uid = user.data['uid'];
        let jom_client = headers['client'];
        let user_id = user.data['id'];

        ApiService.current_user_id = user_id
        localStorage.id = user_id
        // alert('LOGIN ID: ' + localStorage.getItem('id'))
        // this.$store.commit('setCurrentUser', user.data.id)
        // alert('store user id: ' + this.$store.currentUser)
        // this.performingRequest = false
        if (self.client_id != null && self.client_id == 'jom-alexa') {
          if (self.redirect_uri != null) {
            window.location.href = self.redirect_uri + "&access_token=" + uid + " " + jom_client + " " + access_token + "&token_type=Bearer&state=" + self.state;
          }
        } else {
          this.$router.push('/uploader')
        }
        
      }).catch(err => {
        // alert('error login.vue')
        console.log(err)
        this.performingRequest = false
        $('#divMessage').addClass('alert').addClass('alert-danger')
        this.errorMsg = 'Please make sure your credentials are valid'
      })
    }
  }
}
</script>

<style lang="css" scoped>


  .login-wrapper {
    width: 70%;
    margin: 12% auto;
  }

  .form-control:focus {
    border-color: inherit;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .form-signin {
    max-width: 330px;
    padding: 10% 15px;
    margin: 0 auto;
  }
  .form-signin .form-signin-heading,
  .form-signin .checkbox {
    margin-bottom: 10px;
  }
  .form-signin .checkbox {
    font-weight: normal;
  }
  .form-signin .form-control {
    position: relative;
    height: auto;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    padding: 10px;
    font-size: 16px;
    margin-bottom: 10%;
  }
  .form-signin .form-control:focus {
    z-index: 2;
  }
  .form-signin input[type="email"] {
    outline: none !important;
    margin-bottom: 10px;
    border-radius: 20px;
  }

  .form-signin input[type="password"] {
    outline: none !important;
    margin-bottom: 30px;
    border-radius: 20px;
  }

  button {
    border: none !important;
    border-width: 0;
    border-radius: 20px !important;
    background-image: linear-gradient(to right, #F54B64 0%, #F78361 100% )
  }


  .login-logo {
    max-width: -webkit-fill-available;
    /* max-width: 100%; */
    display: block;
    width: 100%;
    height: auto;
    margin-bottom: 40px;
  }
  span {
    font-size: .6em;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue